"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _provider = require("../../lib/provider");
var _configUtils = require("../../lib/config-utils");
var _globals = require("../../lib/constants/globals");
var _providerBadges = _interopRequireDefault(require("../ProviderBadges/provider-badges"));
var _providerBooking = _interopRequireDefault(require("../ProviderBooking/provider-booking"));
var _providerImage = _interopRequireDefault(require("../ProviderImage/provider-image"));
var _providerLocations = _interopRequireDefault(require("../ProviderLocations/provider-locations"));
var _providerLogos = _interopRequireDefault(require("../ProviderLogos/provider-logos"));
var _providerProfileLink = _interopRequireDefault(require("../ProviderProfileLink/provider-profile-link"));
var _providerRating = _interopRequireDefault(require("../ProviderRating/provider-rating"));
var _providerSummary = _interopRequireDefault(require("../ProviderSummary/provider-summary"));
var _virtualProviderDogEarBanner = _interopRequireDefault(require("../VirtualProviderDogEarBanner/virtual-provider-dog-ear-banner"));
/* eslint-disable react/prop-types */
const ProviderCard = _ref => {
  let {
    provider,
    bookOnlineUrl,
    config,
    searchSummary,
    track,
    bookingCallback,
    reviewCallback,
    summaryCallback,
    apptInfo,
    onClickShowAvailability,
    availabilityTilesMessages,
    reviewUrl,
    summaryUrl,
    lazyLoadImg,
    shouldDisplayAvailability,
    availabilityLinkTarget,
    onTimeSlotsClick,
    onAvailabilityTilesLoaded,
    slots,
    slotsStatus,
    getLocationUrl,
    locationCallback,
    locationCTA
  } = _ref;
  const trackProvider = function (message) {
    let event_data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return track(message, {
      ...event_data,
      provider_id: provider.id
    });
  };
  const booking = /*#__PURE__*/_react.default.createElement(_providerBooking.default, {
    provider: provider,
    modalDisplay: config.modal_display,
    bookingCallback: bookingCallback,
    shouldDisplayAvailability: shouldDisplayAvailability,
    slotsStatus: slotsStatus,
    track: trackProvider
  });
  return /*#__PURE__*/_react.default.createElement(_styles.ProviderContainer, {
    "data-view": "consumer-provider",
    "data-testid": "ProviderCard",
    id: provider.id
  }, /*#__PURE__*/_react.default.createElement(_virtualProviderDogEarBanner.default, {
    provider: provider
  }), /*#__PURE__*/_react.default.createElement(_styles.ProviderTop, null, /*#__PURE__*/_react.default.createElement(_styles.ProviderDescription, null, /*#__PURE__*/_react.default.createElement(_styles.ProviderImages, {
    "data-testid": "ProviderImage"
  }, /*#__PURE__*/_react.default.createElement(_providerImage.default, {
    provider: provider,
    summaryCallback: summaryCallback,
    summaryUrl: summaryUrl,
    track: trackProvider,
    lazyLoadImg: lazyLoadImg
  }), /*#__PURE__*/_react.default.createElement(_providerLogos.default, {
    provider: provider,
    logoConfigs: config.logos,
    facets: config.facets
  })), /*#__PURE__*/_react.default.createElement(_styles.ProviderInfo, null, /*#__PURE__*/_react.default.createElement(_styles.ProviderName, null, /*#__PURE__*/_react.default.createElement(_providerProfileLink.default, {
    provider: provider,
    pageSection: _globals.LOGGING.PAGE_SECTION.PROVIDER_NAME,
    navCallback: summaryCallback,
    navUrl: summaryUrl,
    track: trackProvider
  }, (0, _provider.getProviderDisplayName)(provider))), /*#__PURE__*/_react.default.createElement(_providerBadges.default, {
    provider: provider,
    badgeFields: (0, _configUtils.getBadgeFields)(config)
  }), /*#__PURE__*/_react.default.createElement(_providerRating.default, {
    provider: provider,
    reviewCallback: reviewCallback,
    reviewUrl: reviewUrl,
    track: trackProvider
  }), /*#__PURE__*/_react.default.createElement(_providerSummary.default, {
    provider: provider,
    summaryData: (0, _configUtils.getSummaryData)(config),
    facets: config.facets
  }))), /*#__PURE__*/_react.default.createElement(_styles.DesktopBooking, null, booking)), /*#__PURE__*/_react.default.createElement(_styles.ProviderBottom, null, /*#__PURE__*/_react.default.createElement(_providerLocations.default, {
    locations: provider.locations,
    searchSummary: searchSummary,
    track: trackProvider,
    provider: provider,
    bookOnlineUrl: bookOnlineUrl,
    apptInfo: apptInfo,
    onClickShowAvailability: onClickShowAvailability,
    availabilityTilesMessages: availabilityTilesMessages,
    shouldDisplayAvailability: shouldDisplayAvailability,
    availabilityLinkTarget: availabilityLinkTarget,
    onTimeSlotsClick: onTimeSlotsClick,
    onAvailabilityTilesLoaded: onAvailabilityTilesLoaded,
    slots: slots,
    slotsStatus: slotsStatus,
    getLocationUrl: getLocationUrl,
    locationCallback: locationCallback,
    locationCTA: locationCTA
  }), /*#__PURE__*/_react.default.createElement(_styles.MobileBooking, null, booking)));
};
/* eslint-enable react/prop-types */
var _default = exports.default = ProviderCard;
ProviderCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderCard"
};